import React from 'react';
import { useALCContext, ALC_STATES } from '../context/ALCContext';

const ALCStepper: React.FC = () => {
    const { state } = useALCContext();

    const allSteps = [
        { id: 1, label: "Request Info" },
        { id: 2, label: "QA Accept" },
        { id: 3, label: "Checklist Fill" },
        { id: 4, label: "Action Plan" },
        { id: 5, label: "Re-Verify" },
        { id: 6, label: "Finished" }
    ];

    let activeIndex = 0;
    switch (state.currentState) {
        case ALC_STATES.INIT_PRODUCTION:
            activeIndex = 0;
            break;
        case ALC_STATES.PENDING_QA_ACCEPTANCE:
            activeIndex = 1;
            break;
        case ALC_STATES.QA_CHECKLIST:
            activeIndex = 2;
            break;
        case ALC_STATES.PRODUCTION_ACTION:
            activeIndex = 3;
            break;
        case ALC_STATES.QA_REVERIFYING:
            activeIndex = 4;
            break;
        case ALC_STATES.COMPLETED_PASS:
        case ALC_STATES.SUMMARY:
            activeIndex = 5;
            break;
        default:
            activeIndex = 0;
    }

    const visibleSteps = allSteps.slice(0, activeIndex + 1);

    return (
        <div className="tour-workflow-stepper mb-3" style={{
            background: '#f8fafc',
            border: '1px solid #e2e8f0',
            padding: '12px 18px',
            borderRadius: '6px',
            fontSize: '13px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.02)'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                {visibleSteps.map((step, i) => {
                    const isLast = i === activeIndex;
                    return (
                        <React.Fragment key={step.id}>
                            {isLast ? (
                                <div className="breadcrumb-step active" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: '#2563eb',
                                    color: '#ffffff',
                                    padding: '4px 10px',
                                    borderRadius: '4px',
                                    fontWeight: 600,
                                    boxShadow: '0 1px 2px rgba(37,99,235,0.2)'
                                }}>
                                    <span style={{ marginRight: '5px' }}>{step.id}.</span>
                                    <span>{step.label}</span>
                                </div>
                            ) : (
                                <>
                                    <div className="breadcrumb-step completed" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: '#16a34a',
                                        fontWeight: 500,
                                        gap: '4px'
                                    }}>
                                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>✓</span>
                                        <span>{step.label}</span>
                                    </div>
                                    <div className="breadcrumb-separator" style={{ color: '#cbd5e1', fontWeight: 'bold', margin: '0 4px' }}>
                                        &gt;
                                    </div>
                                </>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default ALCStepper;
